<template>
  <div class="homepage">
    <div class="banner">
      <div class="banner-content">
        <div class="banner-left">
          <div class="banner-title">轻松申请</div>
          <div class="banner-title">快速审批</div>
          <div class="banner-badge">
            <van-icon name="fire-o" color="#fff" size="12" />
            <span>网上申请 方便快捷</span>
          </div>
        </div>
        <div class="banner-right">
          <div class="illustration-circle">¥</div>
          <div class="illustration-dot dot1"></div>
          <div class="illustration-dot dot2"></div>
        </div>
      </div>
    </div>

    <div class="page">
      <div class="form-view">
        <div class="card-header">
          <div class="card-accent-bar"></div>
          <div class="card-title">企业信息登记</div>
        </div>

        <van-form @submit="onSubmit">
          <van-field v-model="enterpriseName" label="企业名称" placeholder="请输入企业名称" :rules="[{ required: true, }]" />
          <van-field v-model="medusaUrl" label="水母地址" placeholder="请输入水母地址" />
          <van-button type="info" round block class="btn-get-report">获取报告</van-button>
        </van-form>

        <div v-if="showQuotaReminder" class="quota-tip" @click="goInvite">{{ quotaReminderText }}</div>

        <div class="history-divider-row">
          <div class="history-line"></div>
          <span class="history-title">历史查询</span>
          <div class="history-line"></div>
        </div>
        <div class="history-select" @click="showHistoryPopup = true">
          <span>{{ selectedHistory || '请选择' }}</span>
          <van-icon name="arrow-down" size="16px" color="#999" />
        </div>
        <van-popup v-model="showHistoryPopup" position="bottom" round class="history-popup">
          <div class="popup-header">
            <h3>选择历史记录</h3>
            <van-icon name="cross" size="20px" @click="showHistoryPopup = false" />
          </div>
          <div class="popup-list">
            <div v-for="item in historyOptions" :key="item.value" class="popup-item" @click="selectHistory(item)">
              <span class="popup-item-text">{{ item.text }}</span>
              <van-icon name="arrow" size="16px" color="#999" />
            </div>
            <div v-if="historyOptions.length === 0" class="popup-empty">暂无历史记录</div>
          </div>
        </van-popup>
      </div>

      <div class="trust-card">
        <div class="trust-divider-row">
          <div class="trust-line"></div>
          <span class="trust-title">可以信赖的融资专家</span>
          <div class="trust-line"></div>
        </div>
        <div class="trust-list">
          <div v-for="(item, i) in trustItems" :key="i" class="trust-item">
            <div class="trust-icon-wrap" :style="{ backgroundColor: item.bgColor }">
              <van-icon :name="item.vanIcon" :color="item.color" size="22" />
            </div>
            <div class="trust-item-label">{{ item.label }}</div>
            <div class="trust-item-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-tabbar v-model="active" color="#1566C1">
      <van-tabbar-item icon="edit" to="/credit/home">录入</van-tabbar-item>
      <van-tabbar-item to="/credit/account" icon="contact">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import request from "@/utils/request";
import user from '@/utils/user'
import { Dialog } from 'vant';
import {
  getMyReportRecords,
  getDepartmentReportRecords,
  getAllReportRecords,
} from "@/api/report";

export default {
  data() {
    return {
      duty: -1,
      active: 0,
      enterpriseName: "",
      medusaUrl: "",
      currentUser: user.getCacheUserData() || {},
      obtainReportUrl: "https://uat.bigdataxy.com",
      clientId: 20311851,
      listQuery: {
        pageInfo: {
          pageSize: 9999,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: true,
        employeeId: null,
        enterpriseNameLike: "",
      },
      historyOptions: [],
      showHistoryPopup: false,
      selectedHistory: '',
      loading: false,
      finished: false,
      trustItems: [
        { vanIcon: 'shield-o', label: '安全可靠', desc: '严格数据保护', color: '#1565C0', bgColor: 'rgba(21, 101, 192, 0.12)' },
        { vanIcon: 'upgrade', label: '专业高效', desc: '快速审批通道', color: '#00897B', bgColor: 'rgba(0, 137, 123, 0.12)' },
        { vanIcon: 'medal-o', label: '权威认证', desc: '持牌金融机构', color: '#F57C00', bgColor: 'rgba(245, 124, 0, 0.12)' },
      ],
    }
  },
  created() {
    this.duty = user.getUserDuty()
    this.syncCurrentUser()
    this.getMyReportRecords()
    this.getUnreadCount()
  },
  computed: {
    showQuotaReminder() {
      return !this.currentUser.isUnlimited && this.currentUser.remainingQuota !== null && this.currentUser.remainingQuota !== undefined;
    },
    isQuotaExhausted() {
      return !this.currentUser.isUnlimited && Number(this.currentUser.remainingQuota ?? 0) <= 0;
    },
    quotaReminderText() {
      const remaining = Math.max(0, Number(this.currentUser.remainingQuota ?? 0));
      return `当前可用 ${remaining}/3 次，邀请好友解锁无限使用`;
    },
  },
  methods: {
    async onSubmit() {
      if (this.isQuotaExhausted) {
        this.goInvite();
        return;
      }
      request.post("/Data/ReportTask/CreateReportRecord", { enterpriseName: this.enterpriseName, medusaUrl: this.medusaUrl }).then(async res => {
        await this.syncCurrentUser();
        this.$router.push({
          path: '/credit/report',
          query: { t: 0, id: res.data.data.id }
        })
      })
    },
    async init() {
      return;
    },
    syncCurrentUser() {
      return request.get("/User/AccountMng/GetUserInfo").then((res) => {
        const base = user.getCacheUserData() || {};
        const userData = Object.assign({}, base, res.data.data || {});
        this.currentUser = userData;
        user.cacheUserData(userData);
        return userData;
      }).catch(() => {
        return null;
      });
    },
    getMyReportRecords() {
      if (this.duty == 1) {
        getMyReportRecords(this.listQuery)
          .then((res) => {
            this.historyOptions = res.data.data.data.map((item) => ({
              ...item,
              text: item.enterpriseName,
              value: item.id,
            }))
          })
      } else if (this.duty == 2) {
        getDepartmentReportRecords(this.listQuery)
          .then((res) => {
            this.historyOptions = res.data.data.data.map((item) => ({
              ...item,
              text: item.enterpriseName,
              value: item.id,
            }))
          })
      } else if (this.duty == 3 || this.duty == 99) {
        getAllReportRecords(this.listQuery)
          .then((res) => {
            this.historyOptions = res.data.data.data.map((item) => ({
              ...item,
              text: item.enterpriseName,
              value: item.id,
            }))
          })
      }
    },
    async getToken() {
      return new Promise(function (resolve) {
        request.get("/Data/ReportTask/GetToken").then((res) => {
          resolve(res.data.data);
        })
      })
    },
    async getTaskId() {
      var slef = this;
      return new Promise(function (resolve) {
        request.post("/Data/ReportTask/CreateTaskId", { enterpriseName: slef.enterpriseName, medusaUrl: slef.medusaUrl },).then(res => {
          resolve(res.data.data);
        })
      })
    },
    onHistoryChange(value) {
      this.$router.push({
        path: '/credit/report',
        query: { t: 0, id: value }
      })
    },
    selectHistory(item) {
      this.selectedHistory = item.text;
      this.showHistoryPopup = false;
      this.$router.push({
        path: '/credit/report',
        query: { t: 0, id: item.value }
      });
    },
    onLoadHistory() {
      this.finished = true;
      this.loading = false;
    },
    getUnreadCount() {
      request.get('/Common/Message/GetUnreadCount')
        .then((res) => {
          if (res.data && res.data.data > 0) {
            Dialog.alert({
              title: '提示',
              message: `您有 ${res.data.data} 条待处理消息，是否查看？`,
              confirmButtonText: '查看',
              cancelButtonText: '取消'
            })
              .then(() => {
                this.$router.push('/credit/message');
              })
              .catch(() => {
              });
          }
        })
        .catch((error) => {
          console.error('获取未读消息数量失败:', error);
        });
    },
    goInvite() {
      this.$router.push('/credit/invite');
    },
  }
}
</script>

<style lang="less" scoped>
.homepage {
  font-size: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F5F7FF;
  padding: 16px;
}

.page {
  flex: 1;
  overflow-y: auto;
}

.banner {
  margin-bottom: 16px;
  border-radius: 16px;
  overflow: hidden;
  min-height: 140px;
  background: linear-gradient(to right, #1566C1 0%, #3FA2F3 100%);
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
}

.banner-left {
  flex: 1;
  min-width: 0;
}

.banner-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  line-height: 32px;
}

.banner-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 5px 12px;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.banner-right {
  width: 90px;
  height: 90px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.illustration-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
}

.illustration-dot {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
}

.dot1 {
  width: 16px;
  height: 16px;
  top: 0;
  right: 4px;
}

.dot2 {
  width: 10px;
  height: 10px;
  bottom: 6px;
  left: 0;
}

.form-view {
  background: #fff;
  margin-bottom: 6px;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.title {
  font-size: 1rem;
  color: #000;
  padding: 0 0 1rem 1rem;
  font-weight: bold;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.card-accent-bar {
  width: 4px;
  height: 20px;
  border-radius: 2px;
  background: #1566C1;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #0D1B3E;
}

.form-view ::v-deep .van-cell {
  padding: 16px;
}

.form-view ::v-deep .van-field__label {
  width: 70px;
  margin-right: 12px;
}

.btn-get-report {
  width: 100%;
  padding: 14px;
  border: none;
  margin-top: 20px;
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-get-report:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-get-report:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.quota-tip {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(245, 124, 0, 0.10);
  color: #D56A00;
  font-size: 13px;
  line-height: 1.6;
  cursor: pointer;
}

.history-divider-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
  margin-bottom: 14px;
}

.history-line {
  flex: 1;
  height: 1px;
  background: #E3E8F5;
}

.history-title {
  font-size: 15px;
  font-weight: 600;
  color: #0D1B3E;
}

.history-select {
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
  padding: 14px 16px;
  background: #F5F7FF;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
}

.history-select-text {
  font-size: 14px;
  color: #0D1B3E;
}

.history-select-text.placeholder {
  color: #9DAAC0;
}

.qiyeinput {
  text-align: right !important;
  font-size: .8rem !important;
}

.history-search {
  margin: 2rem 1rem;
}

.history-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.history-select span {
  font-size: 0.9rem;
  color: #333;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.popup-header .van-icon {
  cursor: pointer;
  color: #999;
}

.popup-header .van-icon:hover {
  color: #333;
}

.history-popup {
  max-height: 80vh;
}

.popup-list {
  max-height: calc(80vh - 52px);
  overflow-y: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-item:active {
  background: #f5f7ff;
}

.popup-item-text {
  font-size: 14px;
  color: #333;
}

.popup-empty {
  padding: 40px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.trust-card {
  background: #fff;
  border-radius: 16px;
  margin-bottom: 60px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.trust-divider-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.trust-line {
  flex: 1;
  height: 1px;
  background: #E3E8F5;
}

.trust-title {
  font-size: 15px;
  font-weight: 600;
  color: #0D1B3E;
}

.trust-list {
  display: flex;
  justify-content: space-around;
  gap: 8px;
}

.trust-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.trust-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.trust-item-label {
  font-size: 13px;
  font-weight: 600;
  color: #0D1B3E;
  margin-bottom: 4px;
}

.trust-item-desc {
  font-size: 11px;
  color: #9DAAC0;
}

:deep(.van-tabbar-item--active) {
  color: #1566C1 ;
}

:deep(.van-tabbar-item--active .van-tabbar-item__icon) {
  color: #1566C1 ;
}

:deep(.van-tabbar-item--active .van-icon) {
  color: #1566C1 ;
}

:deep(.van-tabbar) {
  --van-tabbar-item-active-color: #1566C1 !important;
}
</style>
